export default "__VITE_ASSET__76190625__"